// eslint-disable camelcase

import addAuthHeader from '../utilities/auth';
import API from '../constants/apiConstants';
import { IRegistration } from '../utilities/backendTypes';
import handleResponse from '../utilities/handleResponse';

const apiUrl = process.env.REACT_APP_API;

interface BodyArqs {
  project_id: number,
  service_id: number,
  email_integration_id: number,
  name: string,
  fields: {
    first_name: string,
    last_name: string,
    company: string,
    address: string,
    email_address: string,
    privacy: boolean,
  }
}

function registerUser(body: BodyArqs): Promise<IRegistration> {
  const requestOptions = {
    method: 'POST',
    headers: addAuthHeader({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(body),
  };
  return fetch(`${apiUrl}${API.FORM}`, requestOptions).then(handleResponse);
}

const registrationService = {
  registerUser,
};

export default registrationService;
